import {type FC, type PropsWithChildren, useMemo} from 'react';

import type {ContainerBinder} from '../ContainerBinder';

import {ROOT_CONTAINER_KEY} from '../utils';
import {InjectionContext} from './InjectionContext';

type Props = PropsWithChildren<{
  container: ContainerBinder.Container;
}>;

export const InjectionProvider: FC<Props> = ({children, container}) => {
  const containers = useMemo(
    () => new Map([[ROOT_CONTAINER_KEY, container]]),
    [container],
  );

  return (
    <InjectionContext.Provider value={containers}>
      {children}
    </InjectionContext.Provider>
  );
};
